module.exports = {
	"network": {
		"connect": 0,
		"listen": 0,
		"maxconnections": 0
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Presets/nosync.json
 ** module id = 43
 ** module chunks = 0
 **/